import { createIcon } from '../../createIcon';
import { withIcon } from '../../withIcon';
import { ArrowShortDownSvg } from './ArrowShortDown';

export const ArrowShortDownIcon = createIcon('arrowShortDown', ArrowShortDownSvg);
/**
 * @deprecated используйте ArrowShortDownIcon
 */
export const withArrowShortDownIcon = withIcon('arrowShortDown', ArrowShortDownSvg);
